import React from 'react'
import { get } from 'supporticon/utils/client'

import Button from '../../../../ui/Button'
import Icon from 'constructicon/icon'
import Section from 'constructicon/section'

class DisconnectStrava extends React.Component {
  constructor () {
    super()
    this.state = { status: null }
  }

  render () {
    const { onChange, page, user } = this.props
    const { status } = this.state

    return (
      <div>
        <Button
          background='strava'
          onClick={() => {
            this.setState({ status: 'fetching' })
            disconnectFitness(page, user)
              .then(() => onChange())
              .catch(error => {
                this.setState({ status: 'failed' })
                return Promise.reject(error)
              })
          }}>
          <Icon
            name={status === 'fetching' ? 'loading' : 'strava'}
            size={1.5}
            spin={status === 'fetching'}
          />
          <span>Disconnect from Strava</span>
        </Button>
        {status === 'failed' && (
          <Section
            background='danger'
            foreground='light'
            margin={{ t: 0.5 }}
            radius='small'
            spacing={{ y: 0.5, x: 1 }}>
            There was an unexpected error
          </Section>
        )}
      </div>
    )
  }
}

const disconnectFitness = (page, user) => {
  const headers = {
    Authorization: [user.authType, user.token].join(' ')
  }

  return get(`v1/fitness/disconnect/${page.slug}`, {}, {}, { headers })
}

export default DisconnectStrava
